var selectUrlBlock = {
    $selectUrlBlock: $('.select-url-block'),

    init: function() {
        var _this = this;

        if (!_this.$selectUrlBlock.length) {
            return;
        }

        _this.$select = _this.$selectUrlBlock.find('select');
        _this.listener();
    },

    listener: function() {
        var _this = this;

        _this.$select.change(function() {
            _this.goToUrl($(this));
        });
    },

    goToUrl: function($select) {
        window.location.href = $select.val();
    }
};
